import {
  NotaryProduct,
  NotaryProductResource,
  Step
} from '@ligo/bv-flow/store';
import { ApiService, nully } from '@ligo/shared/utils';
import { AnbiStichtingResource } from './definitions/anbi-stichting';
import { useMainResource } from './resources/main';
import { shareholderResources } from './resources/shareholders';
import { paymentResource, ShareholderType } from '../../share';
import { getSteps, addBVtoNewCompanies } from '../../tools';
import { acceptShareholder, NotaryProductSlug } from '../../product_structure';

const steps: Array<Step> = [
  {
    name: 'stichting.company_name.name',
    completed: false
  },
  {
    name: 'stichting.shareholder_information.name',
    parts: 1,
    currentPart: 0,
    completed: false
  },
  {
    name: 'stichting.holding_upsell.name',
    parts: 2,
    currentPart: 0,
    completed: false
  },
  {
    name: 'stichting.preview_documents.name',
    completed: false
  }
];
interface AnbiStichtingAPIResponse {
  product_data: AnbiStichtingResource;
  upsell_package: any;
}

const url = 'anbi_stichting_oprichten/';
const path = 'anbi_stichting_oprichten';
const locale = 'anbi_stichting_oprichten';
const typeId = 16;
const slug = NotaryProductSlug.ANBI_STICHTING;
const finalStep = 3;

const SHAREHOLDER_PREFIX = 'p';
const SHAREHOLDER_NAME_LENGTH = 2;

const saveToAPI = async (product: NotaryProduct, sendStep = true) => {
  const data = product.resources['main'].fieldData();
  Object.keys(product.resources).forEach((x) => {
    if (
      x.length == SHAREHOLDER_NAME_LENGTH &&
      x.startsWith(SHAREHOLDER_PREFIX) &&
      acceptShareholder(product.resources[x])
    ) {
      data[x] = addBVtoNewCompanies(product.resources[x].fieldData());
    }
  });
  const nextStep = sendStep ? product.getStepIncrement() : 0;
  data['step'] = product.step + nextStep;
  data['temporal_step'] = product.temporalStep + nextStep;
  data['substep'] = product.substep;
  const request = product.url + product.uuid;
  console.log('PayLoad', data);
  try {
    await ApiService.patch(request, data);
  } catch (error) {
    console.log('PATCH ERROR', error);
  }
};

const loadFromAPI = async (product: NotaryProduct) => {
  if (product.uuid) {
    const response = await ApiService.get<AnbiStichtingAPIResponse>(
      product.url + product.uuid
    );
    console.log('GET', response);
    product.upsellPackageData = response.data.upsell_package;
    const { step, temporalStep, substep } = getSteps(
      product.uuid,
      response.data.product_data
    );
    product.step = step;
    product.temporalStep = temporalStep;
    product.substep = substep;
    product.updateFromJSON(response.data);
  }
};

export const useBV = (uuid?: string) => {
  const resources = {
    ...useMainResource(),
    ...shareholderResources(),
    ...paymentResource(locale)
  };
  return new NotaryProduct(
    resources,
    locale,
    url,
    path,
    saveToAPI,
    loadFromAPI,
    'stichting-handler',
    steps,
    typeId,
    slug,
    finalStep,
    uuid,
    false
  );
};
